module.exports = __webpack_public_path__ + "img/store-badge-apple.7aa0d6c0.svg";